"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = void 0;
const exception_1 = require("../exception");
const number_1 = require("../number");
const compareDate = (a, b) => {
    if (a.year > b.year) {
        return 1;
    }
    else if (a.year < b.year) {
        return -1;
    }
    if (a.month > b.month) {
        return 1;
    }
    else if (a.month < b.month) {
        return -1;
    }
    if (a.day > b.day) {
        return 1;
    }
    else if (a.day < b.day) {
        return -1;
    }
    return 0;
};
const compareMonth = (a, b) => a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
const compareNumber = (a, b) => {
    (0, number_1.unitCheck)(a, b);
    const baseValueA = (0, number_1.toBaseUnit)(a);
    const baseValueB = (0, number_1.toBaseUnit)(b);
    return baseValueA.comparedTo(baseValueB);
};
const compareString = (a, b) => a.value.localeCompare(b.value);
const compareTime = (a, b) => {
    if (a.hour > b.hour) {
        return 1;
    }
    else if (a.hour < b.hour) {
        return -1;
    }
    if (a.minute > b.minute) {
        return 1;
    }
    else if (a.minute < b.minute) {
        return -1;
    }
    if (a.second > b.second) {
        return 1;
    }
    else if (a.second < b.second) {
        return -1;
    }
    return 0;
};
const compareVector = (a, b) => {
    const minSize = Math.min(a.elements.length, b.elements.length);
    for (let i = 0; i < minSize; ++i) {
        const cmp = (0, exports.compare)(a.elements[i], b.elements[i]);
        if (cmp !== 0) {
            return cmp;
        }
    }
    return a.elements.length > b.elements.length
        ? 1
        : a.elements.length < b.elements.length
            ? -1
            : 0;
};
const compareWeekday = (a, b) => a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
const compare = (a, b) => {
    if (a.type === b.type) {
        switch (a.type) {
            case "Date":
                return compareDate(a, b);
            case "Month":
                return compareMonth(a, b);
            case "Number":
                return compareNumber(a, b);
            case "String":
                return compareString(a, b);
            case "Time":
                return compareTime(a, b);
            case "Vector":
                return compareVector(a, b);
            case "Weekday":
                return compareWeekday(a, b);
        }
    }
    throw new exception_1.TypeError(`Cannot compare ${a.type.toLowerCase()} with ${b.type.toLowerCase()}.`);
};
exports.compare = compare;
